<template>
    <section class="showcase sk-bg-color">
    <div class="p-0 test">
        <div class="col-lg-12 order-lg-1 my-auto showcase-text sk-title-color">
          <h3>SUKIMATCHで</h3>
          <h1 class="lead mb-0">取引成立したバナー制作実績</h1>
        </div>
      
        <div class="row text-center test">

      <div class="col-lg-4 col-md-6 mb-4">
        <div class="card h-100">
          <img class="card-img-top" src="../assets/img/sukimatch/ba1.jpg" alt="">
          
        </div>
      </div>

      <div class="col-lg-4 col-md-6 mb-4">
        <div class="card h-100">
          <img class="card-img-top" src="../assets/img/sukimatch/ba2.jpg" alt="">
          
        </div>
      </div>

      <div class="col-lg-4 col-md-6 mb-4">
        <div class="card h-100">
          <img class="card-img-top" src="../assets/img/sukimatch/ba3.jpg" alt="">
          
          
        </div>
      </div>

      

 

      <div class="col-lg-4 col-md-6 mb-4">
        <div class="card h-100">
          <img class="card-img-top" src="../assets/img/sukimatch/ba4.png" alt="">
          
        </div>
      </div>

      <div class="col-lg-4 col-md-6 mb-4">
        <div class="card h-100">
          <img class="card-img-top" src="../assets/img/sukimatch/ba5.jpg" alt="">
          
        </div>
      </div>

      <div class="col-lg-4 col-md-6 mb-4">
        <div class="card h-100">
          <img class="card-img-top" src="../assets/img/sukimatch/ba6.jpg" alt="">
          
        </div>
      </div>

      

    </div>


    </div>
  </section>
</template>

<script>
export default {
    
}
</script>

<style>
.test {
    margin: 20px;
    color: #f29211;
}

.sk-title-color {
    color: #ffffff;
}

.sk-bg-color{
    background-color: #f18b02;
}
</style>